import { Link } from "@tanstack/react-router";

import Tooltip from "../../Tooltip";
import { NavItemConfig } from "../../../config/navigation";

interface NavItemProps {
  item: NavItemConfig;
  isActive: boolean;
  collapsed: boolean;
}

export default function NavItem({ item, isActive, collapsed }: NavItemProps) {
  const Icon = item.icon;

  const link = (
    <Link
      to={item.path}
      aria-current={isActive ? "page" : undefined}
      className={`relative flex items-center rounded-md min-h-[44px] transition-colors duration-200 ${
        collapsed ? "justify-center w-11 mx-auto" : "pl-4 pr-3 w-full"
      } ${
        isActive
          ? "bg-primary-50 text-primary font-bold"
          : "text-gray-700 hover:bg-primary-100"
      }`}
    >
      {isActive && !collapsed && (
        <span className="absolute left-0 top-1/2 -translate-y-1/2 h-6 w-1 rounded-r bg-primary" />
      )}
      <Icon className="h-5 w-5 shrink-0" aria-hidden="true" />
      {!collapsed && <span className="ml-3 text-sm">{item.title}</span>}
    </Link>
  );

  if (collapsed) {
    return (
      <li className="mb-1 flex justify-center">
        <Tooltip text={item.title} position="right">
          {link}
        </Tooltip>
      </li>
    );
  }

  return <li className="mb-1">{link}</li>;
}
